<template>
    <v-card
      class="ma-0 pa-3 position-relative"
      height="433"
    >
        <v-container
            class="pa-0 d-flex justify-space-between align-center mb-4 position-static"
        >
            <div class="d-flex align-center gap-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.8146 14.3802C14.094 14.1015 14.3157 13.7704 14.4669 13.406C14.6181 13.0415 14.696 12.6508 14.696 12.2562C14.696 11.8616 14.6181 11.4708 14.4669 11.1064C14.3157 10.7419 14.094 10.4108 13.8146 10.1322C13.2503 9.56854 12.4853 9.25195 11.6876 9.25195C10.89 9.25195 10.125 9.56854 9.56063 10.1322C9.11363 10.5782 8.80063 11.5052 8.58663 12.4822C8.26463 13.9422 8.10363 14.6722 8.68663 15.2542C9.26863 15.8352 9.99963 15.6742 11.4626 15.3542C12.4406 15.1382 13.3676 14.8272 13.8146 14.3802Z" fill="#F11E53"/>
                <path opacity="0.5" d="M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12Z" fill="#F11E53"/>
                <path d="M4.42016 5.47616C4.74683 5.09883 5.09916 4.74716 5.47716 4.42116L5.53016 4.46916L7.03016 5.96916C7.16685 6.11055 7.24254 6.29997 7.24092 6.49662C7.23931 6.69327 7.16052 6.88141 7.02153 7.02054C6.88254 7.15966 6.69446 7.23862 6.49782 7.24042C6.30117 7.24223 6.11168 7.16672 5.97016 7.03016L4.47016 5.53016L4.42016 5.47616ZM2.02816 12.7502C1.99061 12.2509 1.99061 11.7495 2.02816 11.2502H4.00016C4.19908 11.2502 4.38984 11.3292 4.53049 11.4698C4.67115 11.6105 4.75016 11.8013 4.75016 12.0002C4.75016 12.1991 4.67115 12.3898 4.53049 12.5305C4.38984 12.6711 4.19908 12.7502 4.00016 12.7502H2.02816ZM5.47616 19.5802C5.09868 19.2549 4.74603 18.902 4.42116 18.5242L4.47016 18.4692L5.97016 16.9692C6.11168 16.8326 6.30117 16.7571 6.49782 16.7589C6.69446 16.7607 6.88254 16.8397 7.02153 16.9788C7.16052 17.1179 7.23931 17.3061 7.24092 17.5027C7.24254 17.6994 7.16685 17.8888 7.03016 18.0302L5.53016 19.5302L5.47616 19.5802ZM19.5802 18.5242C19.2535 18.9015 18.9015 19.2532 18.5242 19.5792L18.4702 19.5302L16.9702 18.0302C16.8965 17.9615 16.8374 17.8787 16.7964 17.7867C16.7554 17.6947 16.7334 17.5954 16.7316 17.4947C16.7298 17.394 16.7483 17.294 16.786 17.2006C16.8238 17.1072 16.8799 17.0223 16.9511 16.9511C17.0223 16.8799 17.1072 16.8238 17.2006 16.786C17.294 16.7483 17.394 16.7298 17.4947 16.7316C17.5954 16.7334 17.6947 16.7554 17.7867 16.7964C17.8787 16.8374 17.9615 16.8965 18.0302 16.9702L19.5302 18.4702L19.5802 18.5242ZM21.9722 11.2502C22.0097 11.7495 22.0097 12.2509 21.9722 12.7502H20.0002C19.8013 12.7502 19.6105 12.6711 19.4698 12.5305C19.3292 12.3898 19.2502 12.1991 19.2502 12.0002C19.2502 11.8013 19.3292 11.6105 19.4698 11.4698C19.6105 11.3292 19.8013 11.2502 20.0002 11.2502H21.9722ZM18.5242 4.42016C18.9015 4.74683 19.2532 5.09883 19.5792 5.47616L19.5302 5.53016L18.0302 7.03016C17.9615 7.10385 17.8787 7.16295 17.7867 7.20395C17.6947 7.24494 17.5954 7.26698 17.4947 7.26876C17.394 7.27053 17.294 7.25201 17.2006 7.21429C17.1072 7.17657 17.0223 7.12042 16.9511 7.0492C16.8799 6.97798 16.8238 6.89315 16.786 6.79976C16.7483 6.70637 16.7298 6.60634 16.7316 6.50564C16.7334 6.40494 16.7554 6.30563 16.7964 6.21363C16.8374 6.12163 16.8965 6.03883 16.9702 5.97016L18.4702 4.47016L18.5242 4.42016ZM12.7502 2.02816V4.00016C12.7502 4.19908 12.6711 4.38984 12.5305 4.53049C12.3898 4.67115 12.1991 4.75016 12.0002 4.75016C11.8013 4.75016 11.6105 4.67115 11.4698 4.53049C11.3292 4.38984 11.2502 4.19908 11.2502 4.00016V2.02816C11.7495 1.99061 12.2509 1.99061 12.7502 2.02816Z" fill="#F11E53"/>
                </svg>
                <v-card-text class="pa-0 text-body-2">{{ $t('orderPointList') }}</v-card-text>
            </div>
            <v-btn
                color=""
                outlined
                custom
                @click="goto"
            >
            {{ $t('see-all') }}
            </v-btn>
        </v-container>
        <div
          v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')"
          ref="scrollContainer"
          class="wrapper"
        >
            <v-list
                v-if="items != null && items != undefined && items.length > 0"
                class="pa-0"
                :style="{ 'width': ($store.state.isMenuExpanded && windowWidth <= 1280)? 'calc(100% + 45px)' : ''}"
            >
                <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    class="pa-0"
                >
                    <v-list-item-content class="pa-0">
                        <v-container
                            class="pa-0 d-flex justify-space-between align-center"
                        >
                            <v-container
                                class="pa-0 ma-0 d-flex align-center gap-2"
                            >
                                <img
                                  :src="(item.avatar != null && item.avatar.link != null) ? item.avatar.link : require('@/assets/imagePlacholder.png')"
                                  style="cursor: pointer;"
                                  @click="edit(item)"
                                />
                                <v-container
                                    class="pa-0"
                                    :style="{ width: $store.state.isMenuExpanded ? '210px' : 'auto' }"
                                >
                                    <v-container class="pa-0 d-flex align-center gap-1">
                                        <v-card-text class="pa-0 text-caption text--disabled">
                                            {{ item.barcode != null ? '...' + '#' + item.barcode.substring(0, 5) : '' }}
                                        </v-card-text>
                                        <v-card-text
                                          class="pa-0 text-caption"
                                          style="cursor: pointer;"
                                          @click="edit(item)"
                                        >
                                          {{ item.name.length > 25 ? item.name.substring(0, 25) + '...' : item.name }}
                                        </v-card-text>
                                    </v-container>
                                    <v-card-text class="pa-0 text-caption text--disabled">
                                        {{ item.group ? item.group.name : '-' }} {{ item.cat1 ? ', ' + item.cat1.name : '' }}
                                    </v-card-text>
                                </v-container>
                            </v-container>
                            <v-container
                                class="pa-0 ma-0 d-flex align-center gap-2"
                            >
                                <v-card-text
                                    class="pa-0 d-flex align-center gap-1"
                                >
                                    <p style="direction: ltr;" class="mb-0 text-body-2">{{ item.stock ? item.stock.count : '-'}}</p>
                                    <p class="mb-0 text-caption text--disabled">{{ item.unit ? item.unit.fame : '' }}</p>
                                </v-card-text>
                                <!-- <v-icon size="17" style="cursor: pointer;">mdi-close</v-icon> -->
                            </v-container>
                        </v-container>
                        <v-divider class="my-1" />
                    </v-list-item-content>
                </v-list-item>
                <v-container
                  v-if="loadingPaginate"
                  class="text-center pa-2"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    :width="3"
                  />
                </v-container>
            </v-list>
            <div
              v-if="items != null && items != undefined && items.length == 0 && !loading"
              style="margin-top: 100px;"
            >
              <div class="d-flex justify-center align-center">
                <img src="@/assets/dashboard/no-data(3).png" style="width: 150px;height: 60px;" />
              </div>
              <div class="d-flex justify-center align-center mt-5">
                <v-card-text class="pa-0 text-caption">
                  {{ $t('there is no enough information for showing.') }}
                </v-card-text>
              </div>
            </div>
            <v-container
              v-if="loading"
              class="pa-0 d-flex justify-center align-center"
            >
              <v-progress-circular
                :width="3"
                color="blue"
                indeterminate
              />
            </v-container>
        </div>
        <div v-else>
          <div
            style="margin-top: 100px;"
          >
            <div class="d-flex justify-center align-center">
              <img src="@/assets/dashboard/not-access(2).png" style="width: 150px;height: 60px;" />
            </div>
            <div class="d-flex justify-center align-center mt-5">
              <v-card-text class="pa-0 text-caption text-center">
                {{ $t("you don't have access to this information") }}
              </v-card-text>
            </div>
          </div>
        </div>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: []
      },
      items: [],
      loading: false,
      loadingPaginate: false,
      lastPage: null,
      windowWidth: null
    }
  },
  methods: {
    fetchList () {
      if (this.items.length == 0) {
        this.loading = true
      }
      var app = this
      app.$axios.get(this.$endpoint + 'products', {
        params: {
          inventoryStatus: 'orderpoint',
          page: this.options.page,
          typeForm: 'product',
          options: JSON.stringify({ page: this.options.page, itemsPerPage: this.options.itemsPerPage })
        }
      })
        .then(r => {
          this.loading = false
          this.loadingPaginate = false
          this.items.push(...r.data.data)
          this.lastPage = r.data.last_page
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
        })
    },
    handleScroll () {
      const container = this.$refs.scrollContainer
      if (!container) return
      const scrollHeight = container.scrollHeight // Total scrollable height
      const scrollTop = container.scrollTop // How much is scrolled
      const clientHeight = container.clientHeight // Visible height
      if (scrollTop + clientHeight >= scrollHeight) {
        if (this.options.page < this.lastPage) {
          this.loadingPaginate = true
          this.options.page++
          this.fetchList()
        }
      }
    },
    goto () {
      this.$router.push('/product/list')
    },
    edit (item) {
      this.$router.push({ name: 'ProductEdit', params: { id: item.id } })
    }
  },
  mounted () {
    this.fetchList()
    this.$nextTick(() => {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll)
      }
    })
    this.windowWidth = window.innerWidth
  },
  beforeDestroy () {
    this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.container,
.v-card__text {
    width: auto;
}
img {
    width: 36px;
    height: 36px;
    border-radius: 4px;
}
.v-btn[custom] {
    font-size: 8pt !important;
}
.position-static {
    position: static;
}
.position-relative {
    position: relative;
}
.wrapper {
    height: 363px;
    overflow: auto;
}
.wrapper::-webkit-scrollbar {
  display: none;
}
.v-btn--outlined {
    border: thin solid #c0c0c09e;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
</style>
